import React from "react";
import WebhookSystemImg from "../../../../../assets/img/webhook-system.png";
import {
  DOCS_WEBHOOKS_MERGE_TO_YOU_PATH,
  DOCS_WEBHOOKS_THIRD_PARTIES_TO_MERGE_PATH,
  ONBOARDING_ADVANCED_SYNCING_DATA_PATH,
} from "../../../../../router/RouterUtils";
import { Card, Text, Link, Alert } from "@merge-api/merge-javascript-shared";
import FeatureCard from "../shared/FeatureCard";

const Webhooks = () => {
  return (
    <Card className="p-6 mx-auto w-full lg:w-3/4">
      <Text variant="h3" className="mb-1">
        Webhooks
      </Text>
      <Text as="p" className="mb-6 text-gray-40">
        Use Merge webhooks and third-party webhooks to keep your product up to date in real-time
      </Text>

      <Text as="p">
        Merge offers webhooks to send you data when it is updated in connected third-party
        platforms.
      </Text>
      <Text as="p">
        Third-party webhooks will allow you to get near real-time data updates from Merge, without
        having to wait for the next poll.
      </Text>
      <Alert className="my-9" color="gray">
        <span>
          Refer to our{" "}
          <Link target="_blank" href={ONBOARDING_ADVANCED_SYNCING_DATA_PATH}>
            syncing data
          </Link>{" "}
          guide to learn how to effectively sync data using polling and webhooks.
        </span>
      </Alert>
      <Text as="p" className="mb-9">
        Merge offers two webhook systems to send data from third parties to your product:{" "}
        <strong>Merge webhooks</strong> and <strong>third-party webhooks</strong>.
      </Text>
      <img src={WebhookSystemImg} width="100%" />
      <Text variant="h4" className="mb-1">
        Merge webhooks
      </Text>
      <Text as="div" className="mb-6 text-gray-40">
        Data from Merge to You
      </Text>
      <Text as="p">
        Configure Merge webhooks to send updates to your product when Merge has received user data
        updates from third parties.
      </Text>
      <Text as="p">
        Merge offers webhooks for other event types (such as sync completion notifications).
      </Text>
      <Text as="p">
        Learn more in our{" "}
        <Link target="_blank" href={DOCS_WEBHOOKS_MERGE_TO_YOU_PATH}>
          Merge webhook docs
        </Link>
        .
      </Text>
      <FeatureCard
        icon={<></>}
        title="Merge webhooks"
        docsPath={DOCS_WEBHOOKS_MERGE_TO_YOU_PATH}
        className="my-9"
      >
        <Text>Configure Merge webhooks that send data payloads to your product</Text>
      </FeatureCard>

      <Text variant="h4" className="mb-1">
        Third-party webhooks
      </Text>
      <Text as="div" className="mb-6 text-gray-40">
        Data from third-party platforms to Merge
      </Text>
      <Text as="p">
        When data is updated in third parties, third-party webhooks can send data to Merge receivers
        and update your user data in Merge.
      </Text>
      <Text as="p">
        Some integrations offer automatic third-party webhook creation when your user connects their
        account. Merge configures these by interacting with the third-party API.
      </Text>
      <Text as="p">
        Integrations that do not offer automatic third-party webhook creation may have manual
        configuration options.
      </Text>
      <Text as="p">
        Learn more in our{" "}
        <Link target="_blank" href={DOCS_WEBHOOKS_THIRD_PARTIES_TO_MERGE_PATH}>
          Third-party webhook docs
        </Link>
        .
      </Text>
      <FeatureCard
        icon={<></>}
        title="Third-party webhooks"
        docsPath={DOCS_WEBHOOKS_THIRD_PARTIES_TO_MERGE_PATH}
        className="mt-9"
      >
        <Text>
          Configure webhooks in integrated third parties that send data payloads to Merge receivers
        </Text>
      </FeatureCard>
    </Card>
  );
};

export default Webhooks;
